module.exports = __webpack_public_path__ + "static/media/AlannahBorst_2026.b5ac04a7.jpg";